import React, { PureComponent } from 'react';
import Switch from '@material-ui/core/Switch';
import { activateUser, deactivateUser } from '../../api/users';
import ConfirmationModal from '../../components/ConfirmationModal';

export default class ToggleActive extends PureComponent {
    static defaultProps = {
      enabled: true,
    };

    state = {
      checked: this.props.checked,
      loading: true,
      openModal: false,
    };

    componentDidUpdate(_, prevState) {
      const { checked } = this.props;
      const { checked: prevChecked } = prevState;
      checked !== prevChecked && this.setState({ checked });
    }

    openConfirmationModal = () => {
      this.setState({ openModal: true });
    };

    closeConfirmationModal = () => {
      this.setState({ openModal: false });
    };

    handleToggleChecked = async () => {
      const { id } = this.props;
      const { checked } = this.state;
      this.setState({
        checked: !checked,
        openModal: false,
        loading: true,
      });

      (checked ? deactivateUser(id) : activateUser(id))
        .then(() => {}, (error) => {
          this.setState({
            checked,
          });
        })
        .finally(() => {
          this.setState({
            loading: false,
          });
        });
    };

    render() {
      return (
        <>
          <Switch
            size="small"
            color="primary"
            checked={this.state.checked}
            disabled={!this.props.enabled}
            onChange={(e) => this.openConfirmationModal()}
          />
          <ConfirmationModal
            title={`Conferma ${this.state.checked ? 'disattivazione' : 'attivazione'} agenzia`}
            isActive={this.state.openModal}
            isOpen={this.state.openModal}
            onClose={this.closeConfirmationModal}
            handleClose={this.closeConfirmationModal}
            handleSubmit={this.handleToggleChecked}
          >
            Sei sicuro di volere
            {' '}
            {this.state.checked ? 'disattivare' : 'attivare'}
            {' '}
            questa agenzia?
          </ConfirmationModal>
        </>
      );
    }
}
